/**
 * @type {object}
 * @description Namespace for PerformanceMark names
 */
export const PerformanceMarks = {

    /**
     * @type {string}
     * @description Mark when the main application has rendered
     */
    RENDERED: 'app_rendered',

    /**
     * @type {string}
     * @description Mark when the main application has ready
     */
    MOUNTED: 'app_mounted',

    /**
     * @type {string}
     * @description Mark to be added during window.load event
     */
    WINDOW_LOAD: 'window_load'
};
